import { request } from '@koi-design/vix-tools';
import { packApi } from '@/libs/tools';

function getHeaders(data) {
  const headers = {};
  if (data.message_source === 'web_share') {
    headers['cybertron-robot-token'] = data.cybertron_robot_token;
    headers['cybertron-robot-key'] = data.cybertron_robot_key;
    headers['cybertron-app-id'] = 'multi-agent-server';
  }
  return headers;
}

export function createMultiAgentApi(data) {
  return request({
    url: `/api/v1/multi-agent/draft`,
    method: 'post',
    data
  });
}

export function getMultiAgentInfoApi(data) {
  return request({
    url: `/api/v1/multi-agent/draft/${data.id}`,
    method: 'get',
    data
  });
}

export function updateMultiAgentConfigApi(data) {
  return request({
    url: `/api/v1/multi-agent/draft/${data.multi_agent_id}`,
    method: 'put',
    data
  });
}

export function updateMultiAgentNodeApi(data) {
  return request({
    url: `/api/v1/multi-agent/draft/${data.multi_agent_id}/node/${data.node.id}`,
    method: 'put',
    data
  });
}

export function batchUpdatePositionApi(data) {
  return request({
    url: `/api/v1/multi-agent/draft/node/position`,
    method: 'put',
    data
  });
}

export function createMultiAgentNodeApi(data) {
  return request({
    url: `/api/v1/multi-agent/draft/${data.multi_agent_id}/node`,
    method: 'post',
    data,
    removeEmptyFields: false
  });
}

export function deleteMultiAgentNodeApi(data) {
  return request({
    url: `/api/v1/multi-agent/draft/${data.multi_agent_id}/node/${data.node_id}`,
    method: 'delete',
    data
  });
}

export function updateGlobalConfigApi(data) {
  return request({
    url: `/api/v1/multi-agent/draft/${data.multi_agent_id}`,
    method: 'put',
    data
  });
}

export function createSegmentCode(data) {
  const url =
    data.message_source === 'web_share'
      ? '/openapi/v1/gw/multi-agent/segment-code/gen'
      : '/api/v1/multi-agent/segment-code/gen';
  return request({
    url,
    method: 'post',
    data,
    headers: getHeaders(data)
  });
}

export function getSegmentCode(data) {
  const url =
    data.message_source === 'web_share'
      ? '/openapi/v1/gw/multi-agent/segment-code/lasted'
      : '/api/v1/multi-agent/segment-code/lasted';
  return request({
    url,
    method: 'get',
    data,
    headers: getHeaders(data)
  });
}

export function toppingSegmentCodeApi(data) {
  const url =
    data.message_source === 'web_share'
      ? '/openapi/v1/gw/multi-agent/segment/topping'
      : '/api/v1/multi-agent/segment/topping';
  return request({
    url,
    method: 'post',
    data,
    headers: getHeaders(data)
  });
}

export function getMultiAgentConversationApi(data) {
  const url =
    data.message_source === 'web_share'
      ? '/openapi/v1/gw/multi-agent/conversation'
      : '/api/v1/multi-agent/conversation';
  return request({
    url,
    method: 'get',
    data,
    removeEmptyFields: false,
    catchAll: true,
    headers: getHeaders(data)
  });
}

export function getMultiAgentConversationListApi(data) {
  const url =
    data.message_source === 'web_share'
      ? '/openapi/v1/gw/multi-agent/segment'
      : '/api/v1/multi-agent/segment';
  return request({
    url,
    method: 'get',
    data,
    headers: getHeaders(data)
  });
}

export function deleteConversationApi(data) {
  const url =
    data.message_source === 'web_share'
      ? '/openapi/v1/gw/multi-agent/segment'
      : '/api/v1/multi-agent/segment';
  return request({
    url,
    method: 'delete',
    data,
    headers: getHeaders(data)
  });
}

export function renameConversationApi(data) {
  const url =
    data.message_source === 'web_share'
      ? '/openapi/v1/gw/multi-agent/segment'
      : '/api/v1/multi-agent/segment';
  return request({
    url,
    method: 'put',
    data,
    headers: getHeaders(data)
  });
}

export function validateDraftApi(data) {
  return request({
    url: `/api/v1/multi-agent/draft/check`,
    method: 'get',
    data
  });
}

export function getMultiAgentListApi(data) {
  return request({
    url: `/api/v1/multi-agent/draft`,
    method: 'get',
    data
  });
}

export function getMultiAgentDetailsInfoApi(data) {
  return request({
    url: `/api/v1/multi-agent/info/${data.multi_agent_id}`,
    method: 'get',
    data
  });
}

export function getOpenApiMultiAgentDetailsInfoApi(data) {
  return request({
    url: `/openapi/v1/gw/multi-agent/info`,
    method: 'get',
    data,
    headers: getHeaders(data)
  });
}
export function getMultiAgentConversationHistoryApi(data) {
  return request({
    url: `/api/v1/multi-agent/segment/history`,
    method: 'get',
    data,
    removeEmptyFields: false
  });
}

export function getMultiAgentConversionLabelApi(data) {
  return request({
    url: `/api/v1/multi-agent/conversation/tag`,
    method: 'get',
    data,
    removeEmptyFields: false
  });
}

export function updateMultiAgentLike(data) {
  return packApi({
    url: `/api/v1/multi-agent/conversation/feedback`,
    method: 'put',
    data
  });
}

export function deleteMultiAgentConversationTag(data) {
  return packApi({
    url: `/api/v1/multi-agent/conversation/tag`,
    method: 'delete',
    data
  });
}

export function addMultiAgentConversationTag(data) {
  return packApi({
    url: `/api/v1/multi-agent/conversation/tag`,
    method: 'post',
    data
  });
}

export function multiAgentAdminFeedbackApi(data) {
  return packApi({
    url: `/api/v1/multi-agent/segment/feedback`,
    method: 'post',
    data
  });
}

export function getHomelandMultiAgentRobotsApi(data) {
  return request({
    url: '/api/v1/multi-agent/robots/',
    method: 'get',
    data
  });
}